function enhanceClickGoPublicPages() {
	document.querySelectorAll("img.app-logo").forEach((logo) => {
		logo.setAttribute("alt", "Click&GO");
	});
}

if (window.frappe?.ready) {
	frappe.ready(enhanceClickGoPublicPages);
} else {
	document.addEventListener("DOMContentLoaded", enhanceClickGoPublicPages, { once: true });
}
